export enum ProductRecommendationErrorTypes {
  TECHNICAL = 'technical',
  INDISPONIBILITY = 'indisponibility',
  NO_RESULTS = 'noResults',
}
